import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Grid, Typography, IconButton, Collapse, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { WsColors } from 'wisestep-base';

const CollapsibleBox = ({
  children,
  institutionValue,
  department,
  gradScore,
  date,
  expanded,
  onDelete,
  onConfirm,
  isAdd,
  hideDelete = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const theme = useTheme();
  const handleExpandClick = () => setIsExpanded(!isExpanded);
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2, width: '100%' }}>
      <Grid container>
        <Grid container item xs={12} sx={{ backgroundColor: WsColors.TheBlues50 }} columnGap={1}>
          <Grid item xs={1} display="flex" alignItems="start">
            <IconButton
              aria-expanded={isExpanded}
              aria-label="show more"
              onClick={handleExpandClick}
              color="primary"
              sx={{ color: theme.palette.primary.main, mt: 1, px: 1, py: 0.5 }}
            >
              <PlayArrowIcon sx={{ transform: isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)' }} />
            </IconButton>
          </Grid>
          <Grid item container xs={8}>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
              {institutionValue && (
                <Typography
                  variant="h6"
                  onClick={handleExpandClick}
                  sx={{ mt: 1 }}
                >{`${institutionValue} - ${department}`}</Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', alignItems: 'center' }}
              columnGap={0.5}
              pb={1}
            >
              <Typography variant="caption" color="textSecondary" sx={{ fontSize: '13px' }}>
                {Array.isArray(department)
                  ? department.map((dept, deptIndex) => (
                      <React.Fragment key={deptIndex}>
                        {dept}
                        {deptIndex < department.length - 1 && ' '}
                      </React.Fragment>
                    ))
                  : department}
              </Typography>
              <Typography variant="caption" color="textSecondary" sx={{ fontSize: '13px' }}>
                {gradScore && `· ${gradScore}`}
              </Typography>
              <Typography variant="caption" color="textSecondary" sx={{ fontSize: '13px' }}>
                {date ? (date instanceof Date ? date.toLocaleDateString() : date) : ''}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={2} display="flex">
            {isAdd && (
              <IconButton
                aria-expanded={isExpanded}
                aria-label="show more"
                onClick={onConfirm}
                color="primary"
              >
                <FaCheck />
              </IconButton>
            )}
            {!hideDelete && (
              <IconButton
                aria-expanded={isExpanded}
                aria-label="show more"
                onClick={onDelete}
                sx={{ color: WsColors.Red400 }}
              >
                <RiDeleteBin6Line />
              </IconButton>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            {children}
          </Collapse>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CollapsibleBox;
